import { Component, input, inject } from '@angular/core';
import {EActionStatus} from '@app/shared/enums/action-status.enum';
import {selectResendLinkStatus} from '@app/signUp/state/sign-up.selector';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {resendLink} from '../../state/sign-up.actions';
import { LoginInfoComponent } from '../../../shared/components/login-info/login-info.component';
import { Bind } from 'primeng/bind';
import { Button } from 'primeng/button';
import { LanguageSelectorComponent } from '../../../shared/components/language-selector/language-selector.component';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-expired-token',
    templateUrl: './expired-token.component.html',
    styleUrls: ['./expired-token.component.scss'],
    imports: [
        LoginInfoComponent,
        Bind,
        Button,
        LanguageSelectorComponent,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class ExpiredTokenComponent {
  private readonly store = inject(Store);

  readonly email = input('' as string);

  resendLinkStatus$: Observable<EActionStatus>;
  actionStatus = EActionStatus;

  constructor() {
    this.resendLinkStatus$ = this.store.select(selectResendLinkStatus);
  }

  onRequestLink(): void {
    this.store.dispatch(resendLink({email: this.email()}));
  }
}
